import React, { useState } from 'react';
import { copyToClipboard } from '@/shared/utils/exportUtils';

export default function AdminAppDomainSection({ appId, showToast }) {
  const [copiedDomain, setCopiedDomain] = useState(null);

  const domains = [
    {
      label: 'Development Domain',
      domain: `dev.${appId}.zapt.fyi`,
      description: 'Development environment domain'
    },
    {
      label: 'Production Domain',
      domain: `${appId}.zapt.fyi`,
      description: 'Production environment domain'
    }
  ];

  const handleCopy = async (domain, label) => {
    const result = await copyToClipboard(domain);
    if (result.success) {
      setCopiedDomain(label);
      if (showToast) {
        showToast(`Copied: ${domain}`, 'success', 2000);
      }
      setTimeout(() => setCopiedDomain(null), 2000);
    } else {
      if (showToast) {
        showToast('Failed to copy domain', 'error');
      }
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>🌐</span>
          <span>App Domain</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Domain configuration for development and production environments
        </p>
      </div>

      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-900">
          <span className="font-semibold">Note:</span> These domains are used to keep the dev URL static and add structure to the URLs. Before adding a custom domain, apps will use these default domains.
        </p>
      </div>

      <div className="space-y-3">
        {domains.map(({ label, domain, description }) => (
          <div
            key={label}
            className="flex items-center justify-between p-4 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors group"
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 mb-1">{label}</p>
              <p className="text-xs text-gray-500 mb-2">{description}</p>
              <code className="text-sm text-gray-800 font-mono bg-white px-2 py-1 rounded border border-gray-300 block break-all">
                {domain}
              </code>
            </div>
            <button
              onClick={() => handleCopy(domain, label)}
              className="ml-4 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-2 flex-shrink-0"
            >
              {copiedDomain === label ? (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Copied!</span>
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  <span>Copy</span>
                </>
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

